// extracted by mini-css-extract-plugin
export default {"wrapper":"hx","noPadding":"ix","flavor_wrapper":"jx","flavor_button":"kx","vert":"lx","itemContent":"mx","itemName":"nx","blue":"ox","out_of_stock":"px","newFlavorBadge":"qx","fullWidth":"rx","flavor_button_selected":"sx","black":"tx","attribute_wrapper":"ux","toggle_wrapper":"vx"};
    if(module.hot) {
      // 1713912565618
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  